import { USER_JURISDICTION_QUERY, AML_STATUS_QUERY, GRACE_PERIOD_QUERY } from '@gig/magic-messages';
import { WalletViewRouteName } from '../constants/wallet.constants.js';
import { isKYCRequestedByAML, getGracePeriodDaysLeft, Jurisdiction } from '@gig/magic-jurisdictions';

var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
var SOW_WALLET_ACCESS;
(function(SOW_WALLET_ACCESS2) {
  SOW_WALLET_ACCESS2[SOW_WALLET_ACCESS2["OK"] = 0] = "OK";
  SOW_WALLET_ACCESS2[SOW_WALLET_ACCESS2["REDIRECT_TO_HOME"] = 1] = "REDIRECT_TO_HOME";
  SOW_WALLET_ACCESS2[SOW_WALLET_ACCESS2["SOW_BLOCK_MODAL"] = 2] = "SOW_BLOCK_MODAL";
})(SOW_WALLET_ACCESS || (SOW_WALLET_ACCESS = {}));
function isWalletAccessAllowedBySoW(view) {
  return __async(this, null, function* () {
    const [jurisdiction, amlStatus, periods] = yield Promise.all([
      window.queryBus.query(USER_JURISDICTION_QUERY),
      window.queryBus.query(AML_STATUS_QUERY),
      window.queryBus.query(GRACE_PERIOD_QUERY)
    ]);
    if (!amlStatus) {
      return 1;
    }
    const isKYCRequested = isKYCRequestedByAML(amlStatus.status);
    const daysLeft = getGracePeriodDaysLeft(periods);
    if (!isKYCRequested) {
      return 0;
    }
    switch (jurisdiction) {
      case Jurisdiction.SGA:
      case Jurisdiction.UKGC: {
        if (view === WalletViewRouteName.WITHDRAW) {
          return 0;
        }
        return getAccessByGracePeriod(daysLeft);
      }
      default: {
        if (view === WalletViewRouteName.WITHDRAW) {
          return 2;
        }
        return getAccessByGracePeriod(daysLeft);
      }
    }
  });
}
function getAccessByGracePeriod(daysLeft) {
  if (daysLeft > 0) {
    return 0;
  } else {
    return 1;
  }
}

export { SOW_WALLET_ACCESS, isWalletAccessAllowedBySoW };
